"use strict";
// import-sort-ignore
// External dependencies - named imports
import $ from "jquery";
import * as Popper from "@popperjs/core";

// Expose libraries globally for legacy code
window.$ = window.jQuery = $;
window.Popper = Popper;

// External dependencies - side-effect imports (CSS/initialization)
import "./vendor/typeahead.bundle.PATCHED";
// Bloodhound is already exposed globally by typeahead.bundle.PATCHED

// Internal modules - side-effect imports (auto-execute)
import "./modules/add-iframe-title";
import "./modules/cookie-consent";
import "./modules/news-block";
import "./modules/print";
import "./modules/responsive-video";
import "./modules/site-search-autocomplete";

// Internal modules - named imports (need explicit initialization)
import Accordion from "./modules/accordion";
import Collapse from "./modules/collapse";
import FilterAll from "./modules/filter-all";
import FocusSet from "./modules/focus-set";
import MobileNav from "./modules/mobile-nav";
import SideNav from "./modules/side-nav";
import TextToSpeech from "./modules/text-to-speech";

// Initialize modules that need explicit initialization
document.addEventListener("DOMContentLoaded", () => {
  // Initialize all accordions
  Accordion().init();

  // Initialize collapse (Bootstrap replacement)
  Collapse().init();

  FilterAll().init();

  FocusSet().init();
});

TextToSpeech().init();
